import { render, staticRenderFns } from "./FilesSelectedCard.vue?vue&type=template&id=6383a08e&scoped=true"
import script from "./FilesSelectedCard.vue?vue&type=script&lang=js"
export * from "./FilesSelectedCard.vue?vue&type=script&lang=js"
import style0 from "./FilesSelectedCard.vue?vue&type=style&index=0&id=6383a08e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6383a08e",
  null
  
)

export default component.exports